export { default } from "./BitacoraFletes";
